import { render, staticRenderFns } from "./EditGiftPurchaseModal.vue?vue&type=template&id=f95720cc&"
import script from "./EditGiftPurchaseModal.vue?vue&type=script&lang=ts&"
export * from "./EditGiftPurchaseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports